<template>
<div class="banner-style-two footer-area footer-area-agency pt-120 position-relative">
	<div class="container">
		<div class="row">
			<div class="col-xl-12 col-lg-12 col-sm-12 col-12">
				<div class="footer-wrap" style="border-bottom: unset;">
					<div class="row justify-content-between">
						<div class="col-xl-3 col-lg-3 col-md-6 col-sm-6 col-6 sm_no_show">
							<div class="single-widget">
								<div class="footer-title">
									<h4>About Us</h4>
								</div>
								<div class="footer-logo">
									<p>バッテリーメーカーと関係を築いてベストな価格を実現します。またお客様のニーズをメーカーにフィードバックすることで商品の改良も日々行っています。</p>
									<a href="/"><img src="/assets/images/footer-logo.png" alt=""></a>
								</div>
							</div>
						</div>
						<div class="col-xl-2 col-lg-3 col-md-12 col-sm-12 col-12 ">
							<div class="single-widget">
								<div class="footer-title">
									<h4>Explore Links</h4>
								</div>
								<div class="footer-link d-flex justify-content-between flex-wrap">
									<ul class="useful-1">
										<li><a href="/about">会社概要</a></li>
										<li><a href="/philosophy">経営理念</a></li>
										<li><a href="/policy">個人情報保護方針</a></li>
									</ul>
								</div>
							</div>
						</div>
						<div class="col-xl-2 col-lg-2 col-md-6 col-sm-6 col-6 sm_no_show">
							<div class="single-widget">
								<div class="footer-title">
									<h4>Services</h4>
								</div>
								<div class="footer-link">
									<ul>
										<li><a href="/specification">商品について</a></li>
										<li><a href="/price">バッテリー価格表</a></li>
									</ul>
								</div>
							</div>
						</div>
						<div class="col-xl-3 col-lg-6 col-md-6 col-sm-12 col-12">
							<div class="single-widget">
								<div class="footer-title">
									<h4>Contact</h4>
								</div>
								<div class="footer-address">
									<h3>〒{{HomeInfo.PostCode}}<br/>{{HomeInfo.Address}} {{ HomeInfo.Building }}</h3>
								</div>
								<div class="contact-info d-flex align-items-center mt-5">
									<div class="contact-info-icon">
										<img src="/assets/images/icon/phone.png" alt="" style="filter: invert(15%) sepia(95%) saturate(6932%) hue-rotate(358deg) brightness(95%) contrast(112%);">
									</div>
									<div class="contact-info-details">
										<h5>Contact Us</h5>
										<a :href="'tel:'+HomeInfo.Tel" style="line-height:40px">{{HomeInfo.Tel}}</a>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
    <div class="pattern-layer" style="background-image: url(/assets/images/shape/shape-26.png); background-size: cover;"></div>
    <div class="container">
		<div class="row copy-wrap pt-3 pb-3">
			<div class="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12">
				<ul class="copy-social">
					<li><i class="bx bxl-facebook"></i></li>
					<li><i class="bx bxl-instagram"></i></li>
					<li><i class="bx bxl-pinterest-alt"></i></li>
					<li><i class="bx bx-basketball"></i></li>
				</ul>
			</div>
			<div class="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12 mobt-24">
				<div class="copy-text text-lg-end">
					<p style="text-transform: none;"><a href="/">{{HomeInfo.CompanyNo}}</a> Copyright © {{new Date().getFullYear()}} All Rights Reserved.</p>
				</div>
			</div>
		</div>
	</div>
</div>
</template>
<script>
import {ref,onMounted,onUnmounted} from "vue";
import { useRoute} from "vue-router"
export default {
  name: "Footer",
  setup(){
    const initSlick = () => {
         if ($('.curved-circle').length) {
              $('.curved-circle').circleType({
                  position: 'absolute',
                  dir: .95,
                  radius: 85,
                  forceHeight: false,
                  forceWidth: true
              });
          }
          //Submenu Dropdown Toggle
          if ($('.main-nav__main-navigation li.dropdown ul').length) {
              $('.main-nav__main-navigation li.dropdown').append('<button class="dropdown-btn"><i class="fa fa-angle-right"></i></button>');
          }

        function AdaptHeight() {
                const height = $(window).height();
                if ($('#bannercroll')) {
                    $('#bannercroll').css('height', height);
                }
        }
        window.onresize = AdaptHeight();
          function dynamicCurrentMenuClass(selector) {
              let FileName = window.location.href.split('/').reverse()[0];

              selector.find('li').each(function() {
                  let anchor = $(this).find('a');
                  if ($(anchor).attr('href') == FileName) {
                      $(this).addClass('current');
                  }
              });
              // if any li has .current elmnt add class
              selector.children('li').each(function() {
                  if ($(this).find('.current').length) {
                      $(this).addClass('current');
                  }
              });
              // if no file name return 
              if ('' == FileName) {
                  selector.find('li').eq(0).addClass('current');
              }
          }
                
          // mobile menu
          if ($('.main-nav__main-navigation').length) {
              let mobileNavContainer = $('.mobile-nav__container');
              // <a href="https://file.mcts.co.jp" class="search-popup__toggler main-nav__search" onclick="window.open('https://file.mcts.co.jp', '_blank')"  id="fa-user-circle"><i class="far fa-user-circle"></i></a>
              let mainNavContent ='<a href="/" class="side-menu__logo" style="position: absolute;margin-top: -64px;z-index: 9999;padding-left: 20px;left: 120px;"><img src="/assets/images/logo-1-1.png" alt=""></a>' + $('.main-nav__main-navigation').html();
              mobileNavContainer.append(function() {
                  return mainNavContent;
              });
              //Dropdown Button
              mobileNavContainer.find('li.dropdown .dropdown-btn').on('click', function() {
                  $(this).toggleClass('open');
                  $(this).prev('ul').slideToggle(500);
              });

              // dynamic current class        
              let mainNavUL = $('.main-nav__main-navigation').find('.main-nav__navigation-box');
              let mobileNavUL =  mobileNavContainer.find('.main-nav__navigation-box');
              dynamicCurrentMenuClass(mainNavUL);
              dynamicCurrentMenuClass(mobileNavUL);
          }
          if ($('.mc-form').length) {
              var mcURL = $('.mc-form').data('url');
              $('.mc-form').ajaxChimp({
                  url: mcURL,
                  callback: function(resp) {
                      // appending response
                      $('.mc-form__response').append(function() {
                              return '<p class="mc-message">' + resp.msg + '</p>';
                      })
                      // making things based on response
                      if (resp.result === 'success') {
                          // Do stuff
                          $('.mc-form').removeClass('errored').addClass('successed');
                          $('.mc-form__response').removeClass('errored').addClass('successed');
                          $('.mc-form').find('input').val('');
                          $('.mc-form__response p').fadeOut(10000);
                      }
                      if (resp.result === 'error') {
                          $('.mc-form').removeClass('successed').addClass('errored');
                          $('.mc-form__response').removeClass('successed').addClass('errored');
                          $('.mc-form').find('input').val('');
                          $('.mc-form__response p').fadeOut(10000);
                      }
                  }
              });
          }

          if ($('.datepicker').length) {
              $('.datepicker').datepicker();
          }


          if ($('.plan-visit__tab-links').length) {
              var planVisitLink = $('.plan-visit__tab-links').find('.nav-link');
              planVisitLink.on('click', function(e) {
                  var target = $(this).attr('data-target');
                  // animate
                  $('html, body').animate({
                      scrollTop: $(target).offset().top - 50
                  }, 1000);


                  planVisitLink.removeClass('active');
                  $(this).addClass('active');

                  return false;
              })
          }

          if ($('.contact-form-validated').length) {
              $('.contact-form-validated').validate({ // initialize the plugin
                  rules: {
                      fname: {
                          required: true
                      },
                      lname: {
                          required: true
                      },
                      name: {
                          required: true
                      },
                      email: {
                          required: true,
                          email: true
                      },
                      service: {
                          required: true
                      },
                      message: {
                          required: true
                      },
                      subject: {
                          required: true
                      }
                  },
                  submitHandler: function(form) {
                      // sending value with ajax request
                      $.post($(form).attr('action'), $(form).serialize(), function(response) {
                          $(form).parent().find('.result').append(response);
                          $(form).find('input[type="text"]').val('');
                          $(form).find('input[type="email"]').val('');
                          $(form).find('textarea').val('');
                      });
                      return false;
                  }
              });
          }
          if ($('.counter').length) {
              $('.counter').counterUp({
                  delay: 10,
                  time: 1500
              });
          }
          if ($('.img-popup').length) {
              var groups = {};
              $('.img-popup').each(function() {
                  var id = parseInt($(this).attr('data-group'), 10);

                  if (!groups[id]) {
                      groups[id] = [];
                  }

                  groups[id].push(this);
              });


              $.each(groups, function() {

                  $(this).magnificPopup({
                      type: 'image',
                      closeOnContentClick: true,
                      closeBtnInside: false,
                      gallery: {
                          enabled: true
                      }
                  });

              });

          };
          if ($('.wow').length) {
              var wow = new WOW({
                  boxClass: 'wow', // animated element css class (default is wow)
                  animateClass: 'animated', // animation css class (default is animated)

                  mobile: true, // trigger animations on mobile devices (default is true)
                  live: true // act on asynchronously loaded content (default is true)
              });
              wow.init();
          }

          if ($('.video-popup').length) {
              $('.video-popup').magnificPopup({
                  disableOn: 700,
                  type: 'iframe',
                  mainClass: 'mfp-fade',
                  removalDelay: 160,
                  preloader: true,

                  fixedContentPos: false
              });
          }
          if ($('[data-toggle="tooltip"]').length) {
              $('[data-toggle="tooltip"]').tooltip();
          }
          if ($('.stricky').length) {
              $('.stricky').addClass('original').clone(true).insertAfter('.stricky').addClass('stricked-menu').removeClass('original');
          }
          if ($('.scroll-to-target').length) {
              $(".scroll-to-target").on('click', function() {
                  var target = $(this).attr('data-target');
                  // animate
                  $('html, body').animate({
                      scrollTop: $(target).offset().top
                  }, 1000);

                  return false;

              });
          }

          //if ($('.side-menu__toggler').length) {
          $('.side-menu__toggler').on('click', function(e) {
              $('.side-menu__block').toggleClass('active');
              e.preventDefault();
          });
          // }

          if ($('.side-menu__block-overlay').length) {
              $('.side-menu__block-overlay').on('click', function(e) {
                  $('.side-menu__block').removeClass('active');
                  e.preventDefault();
              });
          }

          if ($('.side-content__toggler').length) {
              $('.side-content__toggler').on('click', function(e) {
                  $('.side-content__block').toggleClass('active');
                  e.preventDefault();
              });
          }

          if ($('.side-content__block-overlay').length) {
              $('.side-content__block-overlay').on('click', function(e) {
                  $('.side-content__block').removeClass('active');
                  e.preventDefault();
              });
          }


          if ($('.search-popup__toggler').length) {
              $('.search-popup__toggler').on('click', function(e) {
                  $('.search-popup').addClass('active');
                  e.preventDefault();
              });
          }

          if ($('.search-popup__overlay').length) {
              $('.search-popup__overlay').on('click', function(e) {
                  $('.search-popup').removeClass('active');
                  e.preventDefault();
              });
          }
          $(window).on('scroll', function() {
              if ($('.scroll-to-top').length) {
                  var strickyScrollPos = 100;
                  if ($(window).scrollTop() > strickyScrollPos) {
                      $('.scroll-to-top').fadeIn(500);
                  } else if ($(this).scrollTop() <= strickyScrollPos) {
                      $('.scroll-to-top').fadeOut(500);
                  }
              }
              if ($('.stricked-menu').length) {
                  var headerScrollPos = 100;
                  var stricky = $('.stricked-menu');
                  if ($(window).scrollTop() > headerScrollPos + 160) {
                      //stricky.addClass('stricky-fixed');
                      $('#original-fix').addClass('site-header')
                      $('#logo-menu').attr('src','/assets/images/footer-logo.png')
                      $('#fa-bars').attr('style','color:#162F62')
                      $('#fa-user-circle').attr('style','color:#162F62')
                  } else if ($(this).scrollTop() <= headerScrollPos) {
                      // stricky.removeClass('stricky-fixed');
                      $('#original-fix').removeClass('site-header')
                      $('#logo-menu').attr('src','/assets/images/logo-1-1.png')
                      $('#fa-bars').attr('style','')
                      $('#fa-user-circle').attr('style','')
                  }
              }
          });
          if ($('.accrodion-grp').length) {
              var accrodionGrp = $('.accrodion-grp');
              accrodionGrp.each(function() {
                  var accrodionName = $(this).data('grp-name');
                  var Self = $(this);
                  var accordion = Self.find('.accrodion');
                  Self.addClass(accrodionName);
                  Self.find('.accrodion .accrodion-content').hide();
                  Self.find('.accrodion.active').find('.accrodion-content').show();
                  accordion.each(function() {
                      $(this).find('.accrodion-title').on('click', function() {
                          if ($(this).parent().hasClass('active') === false) {
                              $('.accrodion-grp.' + accrodionName).find('.accrodion').removeClass('active');
                              $('.accrodion-grp.' + accrodionName).find('.accrodion').find('.accrodion-content').slideUp();
                              $(this).parent().addClass('active');
                              $(this).parent().find('.accrodion-content').slideDown();
                          };


                      });
                  });
              });

          };

          if ($('.thm__owl-carousel').length) {
              $('.thm__owl-carousel').each(function() {

                  var Self = $(this);
                  var carouselOptions = Self.data('options');
                  var carouselPrevSelector = Self.data('carousel-prev-btn');
                  var carouselNextSelector = Self.data('carousel-next-btn');
                  var carouselDotsContainer = Self.data('carousel-dots-container');
                  var thmCarousel = Self.owlCarousel(carouselOptions);
                  if (carouselPrevSelector !== undefined) {
                      $(carouselPrevSelector).on('click', function() {
                          thmCarousel.trigger('prev.owl.carousel', [1000]);
                          return false;
                      });
                  }
                  if (carouselNextSelector !== undefined) {
                      $(carouselNextSelector).on('click', function() {
                          thmCarousel.trigger('next.owl.carousel', [1000]);
                          return false;
                      });
                  }
                  if (carouselDotsContainer !== undefined) {
                      $(carouselDotsContainer).find('.owl-dot').on('click', function() {
                          var dotIndex = $(this).index();
                          // $(carouselDotsContainer).find('.owl-dot').removeClass('active');
                          // $(carouselDotsContainer).find('.owl-dot').eq(dotIndex).addClass('active');
                          thmCarousel.trigger('to.owl.carousel', [dotIndex, 1000]);
                      });
                  }
              });
          }

          $(window).on('load', function() {
              if ($('.preloader').length) {
                  $('.preloader').fadeOut('slow');
              }

              if ($('.side-menu__block-inner').length) {
                  $('.side-menu__block-inner').mCustomScrollbar({
                      axis: 'y',
                      theme: 'dark'
                  });
              }


              if ($('.side-content__block-inner').length) {
                  $('.side-content__block-inner').mCustomScrollbar({
                      axis: 'y',
                      theme: 'dark'
                  });
              }

              if ($('.custom-cursor__overlay').length) {

                  // / cursor /
                  var cursor = $(".custom-cursor__overlay .cursor"),
                      follower = $(".custom-cursor__overlay .cursor-follower");

                  var posX = 0,
                      posY = 0;

                  var mouseX = 0,
                      mouseY = 0;

                  TweenMax.to({}, 0.016, {
                      repeat: -1,
                      onRepeat: function() {
                          posX += (mouseX - posX) / 9;
                          posY += (mouseY - posY) / 9;

                          TweenMax.set(follower, {
                              css: {
                                  left: posX - 22,
                                  top: posY - 22
                              }
                          });

                          TweenMax.set(cursor, {
                              css: {
                                  left: mouseX,
                                  top: mouseY
                              }
                          });

                      }
                  });

                  $(document).on("mousemove", function(e) {
                      var scrollTop = window.pageYOffset || document.documentElement.scrollTop;
                      mouseX = e.pageX;
                      mouseY = e.pageY - scrollTop;
                  });
                  $("button, a").on("mouseenter", function() {
                      cursor.addClass("active");
                      follower.addClass("active");
                  });
                  $("button, a").on("mouseleave", function() {
                      cursor.removeClass("active");
                      follower.removeClass("active");
                  });
                  $(".custom-cursor__overlay").on("mouseenter", function() {
                      cursor.addClass("close-cursor");
                      follower.addClass("close-cursor");
                  });
                  $(".custom-cursor__overlay").on("mouseleave", function() {
                      cursor.removeClass("close-cursor");
                      follower.removeClass("close-cursor");
                  });
              }
              if ($('.masonary-layout').length) {
                  $('.masonary-layout').isotope({
                      layoutMode: 'masonry',
                      itemSelector: '.masonary-item'
                  });
              }

              if ($('.post-filter').length) {
                  var postFilterList = $('.post-filter li');
                  // for first init
                  $('.filter-layout').isotope({
                      filter: '.filter-item',
                      animationOptions: {
                          duration: 500,
                          easing: 'linear',
                          queue: false
                      }
                  });
                  // on click filter links
                  postFilterList.children('span').on('click', function() {
                      var Self = $(this);
                      var selector = Self.parent().attr('data-filter');
                      postFilterList.children('span').parent().removeClass('active');
                      Self.parent().addClass('active');


                      $('.filter-layout').isotope({
                          filter: selector,
                          animationOptions: {
                              duration: 500,
                              easing: 'linear',
                              queue: false
                          }
                      });
                      return false;
                  });
              }
              if ($('.post-filter.has-dynamic-filter-counter').length) {
                  // var allItem = $('.single-filter-item').length;

                  var activeFilterItem = $('.post-filter.has-dynamic-filter-counter').find('li');

                  activeFilterItem.each(function() {
                      var filterElement = $(this).data('filter');
                      var count = $('.gallery-content').find(filterElement).length;
                      $(this).children('span').append('<span class="count"><b>' + count + '</b></span>');
                  });
              }
              if ($('.testimonials-two__thumb-carousel').length) {
                  var testiTwoThumbCarousel = new Swiper('.testimonials-two__thumb-carousel', {
                      slidesPerView: 3,
                      spaceBetween: 20,
                      freeMode: true,
                      speed: 1400,
                      watchSlidesVisibility: true,
                      watchSlidesProgress: true,
                      loop: true,
                      autoplay: {
                          delay: 5000
                      },
                  });
              }
              if ($('.testimonials-two__carousel').length) {
                  var testiTwoCarousel = new Swiper('.testimonials-two__carousel', {
                      navigation: {
                          nextEl: '',
                          prevEl: '',
                      },
                      observer: true,
                      observeParents: true,
                      speed: 1400,
                      mousewheel: true,
                      autoplay: {
                          delay: 5000
                      },
                      thumbs: {
                          swiper: testiTwoThumbCarousel
                      }
                  });
              }
          });
    };
    
    const showItems = ref(true)
    function hidden() {
      if (window.innerWidth < 767) {
        showItems.value = false
      }else {
        showItems.value = true
      }
    }
    onMounted(() => {
      initSlick();
      hidden();
    })
    window.addEventListener('resize', hidden)
    onUnmounted(() => {
      window.removeEventListener('resize', hidden)
    })
    
    return{showItems}
  },
}
</script>

<style scoped>

.pattern-layer{
  position: absolute;
  left: 0px;
  bottom: 0px;
  width: 100%;
  height: 521px;
  background-repeat: repeat-x;
  animation: slide 60s linear;
  -webkit-animation: slide 60s linear infinite;
  z-index: -1;
  opacity: 0.5;
}
@keyframes slide {
    from {
        background-position: 0 0
    }
    to {
        background-position: 1920px 0
    }
}

@-webkit-keyframes slide {
    from {
        background-position: 0 0
    }
    to {
        background-position: 1920px 0
    }
}

</style>
